export default __webpack_public_path__ + "bb38edf3146922d28e1beb44b2060cd8.png";